import EditViewPanel from "components/panels/EditViewPanel";
import React from "react";
import { Button } from "semantic-ui-react";
import { UpgradeConfirmation } from "../../components";

interface Props {
  onUpgradeConfirmed: () => void
  upgradeMessage: string
  title: string
}

const ConfirmUpgradePanel = (props: Props) => {
  const onSubmit = (e) => {
    e.preventDefault();
    props.onUpgradeConfirmed();
  };
  return <EditViewPanel
    title={props.title}
  >
    <UpgradeConfirmation
      visible
      upgradeMessage={props.upgradeMessage}
    />
    <div className="flex margin-top-bigger">
      <div className="grow1"></div>
      <div>
        <Button primary onClick={onSubmit}>{RESX.GeneralLabels.ConfirmUpgrade}</Button>
      </div>
    </div>
  </EditViewPanel>;
};

export default ConfirmUpgradePanel;